import React from 'react';
import { GlassCard } from '../../ui/Card';

const ContactSkeleton: React.FC = () => {
    return (
        <section className="section contact-section">
            <div className="container">
                <GlassCard>
                    <div className="skeleton-line skeleton-title" style={{ width: '50%', height: '32px', margin: '0 auto 20px', textAlign: 'center' }}></div>
                    <div className="skeleton-line" style={{ width: '70%', height: '20px', margin: '0 auto 32px', textAlign: 'center' }}></div>
                    <div style={{ display: 'flex', gap: '20px', justifyContent: 'center' }}>
                        <div className="skeleton-line" style={{ width: '200px', height: '48px', borderRadius: '8px' }}></div>
                        <div className="skeleton-line" style={{ width: '48px', height: '48px', borderRadius: '50%' }}></div>
                    </div>
                </GlassCard>
            </div>
        </section>
    );
};

export default ContactSkeleton;
